const state = {
    lockedWorkspaces: [],
    unlockedWorkspaces: [],
    duplicatedWorkspaceId: null,
    importedWorkspace: null,
    workspacesSearchQuery: "",
    workspacesTagsFilters: {
        included: [],
        excluded: [],
    },
    workspacesSortingDirections: {
        name: null,
        lastAccessed: "desc",
    },
    workspacesLoading: false,
    workspaceExportInProgress: false,
};
export default state;
